import TextField from "@/common/components/TextField";
import { CompanyBranchData } from "../../types/companyBranches.type";

interface CardConfigurationProps {
  branchData?: CompanyBranchData;
}

const CardConfiguration = ({ branchData }: CardConfigurationProps) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-lg">
        Configurações do cartão
      </p>

      <div className="flex flex-col gap-2">
        <TextField
          name="name_on_card"
          label="Nome que será impresso no cartão"
          disabled
          value={branchData?.name_on_card || ''}
        />
      </div>
    </div>
  );
}

export default CardConfiguration;
